import React, { useEffect, useState } from "react";
import {
  Typography,
  FormLabel,
  TextField,
  Button,
  Box,
  Grid,
} from "@mui/material";
import { useProyecto } from "../../../data/ProyectoContext";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";
import plusIcon from "../img/PlusIcon.svg";

const Fortalezas = () => {
  const { promptData, setPromptData } = useActividadesContext();
  const [agregarFortaleza, setAgregarFortaleza] = useState(false);
  const [nuevaFortaleza, setNuevaFortaleza] = useState("");
  const [fortalezasClave, setFortalezasClave] = useState(
    promptData.fortalezas || []
  );
  const { setProyecto } = useProyecto();

  useEffect(() => {
    setFortalezasClave(promptData.fortalezas || []);
  }, [promptData]);

  const handleGuardarFortaleza = () => {
    if (nuevaFortaleza.trim() !== "") {
      const nuevasFortalezas = [...fortalezasClave, nuevaFortaleza];
      setFortalezasClave(nuevasFortalezas);
      setNuevaFortaleza("");
      setAgregarFortaleza(false);
      setPromptData((prevData) => ({
        ...prevData,
        fortalezas: nuevasFortalezas,
      }));
    }
  };

  const handleAgregarFortaleza = () => {
    setAgregarFortaleza(true);
  };

  const handleEliminarFortaleza = (index) => {
    // Obtiene la fortaleza clave a eliminar
    const fortalezaAEliminar = fortalezasClave[index];
    const nuevosFortaleza = fortalezasClave.filter((_, i) => i !== index);
    // Actualiza el estado de las fortalezas clave, eliminando la fortaleza clave seleccionada
    setFortalezasClave(nuevosFortaleza);
    setPromptData((prevData) => ({
      ...prevData,
      fortalezas: nuevosFortaleza,
    }));
    // Actualiza el estado del proyecto, eliminando la fortaleza clave seleccionada
    setProyecto((prevProyecto) => ({
      ...prevProyecto,
      fortalezas_clave: prevProyecto.fortalezas_clave
        ? prevProyecto.fortalezas_clave.filter(
            (fortaleza) => fortaleza !== fortalezaAEliminar
          )
        : [],
    }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={3}>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Typography
          sx={{
            fontFamily: "montserrat",
            fontSize: "1.25rem",
            fontWeight: "bold",
            color: "#336B87",
          }}
        >
          Fortalezas
        </Typography>
      </Box>
      <FormLabel sx={{ fontFamily: "montserrat", fontSize: "0.85rem" }}>
        Menciona los aspectos positivos como habilidades, conocimientos o
        actitudes positivas del estudiante en campos separados. Ejemplo:
        dedicación al estudio, compañerismo y colaboración
      </FormLabel>
      {agregarFortaleza ? (
        <Grid container spacing={2} mt={3} alignItems="center">
          <Grid item xs={12} sm={8}>
            <TextField
              label="Nueva fortaleza"
              variant="outlined"
              fullWidth
              value={nuevaFortaleza}
              onChange={(e) => setNuevaFortaleza(e.target.value)}
              sx={{ fontFamily: "montserrat", mr: 2, mb: 2 }}
              InputProps={{
                sx: {
                  borderRadius: 2,
                  fontFamily: "montserrat",
                  fontSize: "0.75rem",
                  color: "#336B87",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              sx={{
                backgroundColor: "#336B87",
                "&:hover": { backgroundColor: "#2B7C83" },
                fontFamily: "montserrat",
                fontWeight: "bold",
              }}
              variant="contained"
              onClick={handleGuardarFortaleza}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mt: 3,
            flexWrap: "wrap",
          }}
        >
          {fortalezasClave.map((fortaleza, index) => (
            <Box key={index} sx={{ display: "inline-block", m: 1 }}>
              <Button
                variant="outlined"
                onClick={() => handleEliminarFortaleza(index)}
                sx={{
                  color: "#336B87",
                  fontFamily: "Montserrat",
                  fontWeight: "medium",
                  fontSize: "1.25rem",
                  borderColor: "rgba(51, 107, 135, 0.3)",
                  borderRadius: 50,
                  backgroundColor: "rgba(51, 107, 135, 0.3)",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#FFF",
                    borderColor: "#336B87",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "1.25rem",
                    display: "flex",
                    alignItems: "center",
                    color: "#336B87",
                    textTransform: "none",
                  }}
                >
                  {fortaleza}
                  <HighlightOffIcon sx={{ ml: 1, color: "#CD5C5C" }} />
                </Typography>
              </Button>
            </Box>
          ))}
          <Button
            variant="outlined"
            sx={{
              fontFamily: "Montserrat",
              fontWeight: "medium",
              fontSize: "1.25rem",
              borderColor: "rgba(51, 107, 135, 0.3)",
              borderStyle: "dashed",
              borderRadius: 50,
              backgroundColor: "#FFF",
              boxShadow: 3,
              "&:hover": {
                backgroundColor: "rgba(51, 107, 135, 0.3)",
                boxShadow: 6,
                borderColor: "rgba(51, 107, 135, 0.3)",
                borderStyle: "dashed",
              },
              color: "#336B87",
              textTransform: "none",
            }}
            onClick={handleAgregarFortaleza}
          >
            <img
              src={plusIcon}
              alt="Icono"
              style={{ width: "25px", height: "25px" }}
            />
          </Button>
        </Box>
      )}
    </Grid>
  );
};

export default Fortalezas;
